export default "__VITE_ASSET__BIjxoCJt__"